export const GET_ALL_CUSTOMERS = 'GET_ALL_CUSTOMERS';
export const GET_CUSTOMER_CREDITS = 'GET_CUSTOMER_CREDITS';
export const GET_CUSTOMER_TRANSACTIONS = 'GET_CUSTOMER_TRANSACTIONS';
export const GET_CUSTOMER_HISTORY = 'GET_CUSTOMER_HISTORY';
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const PURCHASED_TICKET = 'PURCHASED_TICKET';
